module.exports = __webpack_public_path__ + "static/media/1259_elements_procedures.ba585d70.png";